import {useState} from 'react';
import {record} from '@solimat/solimat-web-endpoint';

const useGetInfoCertificadoEmpresaIt = () => {
  const [loadingGetInfoCertificadoEmpresaIt, setLoadingGetInfoCertificadoEmpresaIt] = useState(false);
  const [successGetInfoCertificadoEmpresaIt, setSuccessGetInfoCertificadoEmpresaIt] = useState(false);
  const [errorGetInfoCertificadoEmpresaIt, setErrorGetInfoCertificadoEmpresaIt] = useState(null);
  const [infoCertificadoEmpresaIt, setInfoCertificadoEmpresaIt] = useState<null|any>(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);
 
  const getInfoCertificadoEmpresaIt = (userId:string, _cb?:(data:any)=>void) => {
    setLoadingGetInfoCertificadoEmpresaIt(true);
    setSuccessGetInfoCertificadoEmpresaIt(false);
    apiRecord.getInfoCertificadoEmpresaIt(userId)
      .then((res) => {       
        setInfoCertificadoEmpresaIt(res.data);
        setLoadingGetInfoCertificadoEmpresaIt(false);
        setSuccessGetInfoCertificadoEmpresaIt(true);
        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err)=> {
        console.log(err)
        setLoadingGetInfoCertificadoEmpresaIt(false);
        setErrorGetInfoCertificadoEmpresaIt(err)
      })
  }


  return {
    infoCertificadoEmpresaIt,
    getInfoCertificadoEmpresaIt,
    loadingGetInfoCertificadoEmpresaIt,
    successGetInfoCertificadoEmpresaIt,
    errorGetInfoCertificadoEmpresaIt
    };
}

export default useGetInfoCertificadoEmpresaIt;
